

































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { IUser } from 'admiral-core';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { UserIcon } from 'vue-feather-icons';

@Component({
  components: { UserIcon },
})
export default class Avatar extends mixins(BaseMixin) {
  @Prop({ required: false, type: Object })
  u!: IUser;

  @Prop({ required: false, type: Boolean, default: false })
  showUnassigned!: boolean;

  @Prop({ required: false, type: String, default: () => 'md' })
  size!: 'sm' | 'md' | 'md2' | 'lg' | 'xl';

  @Prop({ required: false, type: String })
  clazz!: string;

  @Prop({ required: false, type: String })
  status!: 'offline';

  get avatarSize() {
    return this.size || 'md';
  }
}
